import { createSelector } from '@reduxjs/toolkit';
import { selectCardLoading, selectGridLoading } from '../OperationsReducer/operationsSlice';
import { selectOverallLoading } from '../PerformanceReducer/Overall/overallSlice';
import { selectEcommLoading } from '../PerformanceReducer/Ecommerce/ecommSalesPerfSlice';
import { selectEcomOrderDetailsLoading } from '../PerformanceReducer/Ecommerce/ecomOrderDetailsSlice';
import { selectKeyOperationalMetricsLoading } from '../PerformanceReducer/Ecommerce/keyOperationalMetricsSlice';
import { selectProductSyncLoading } from '../PerformanceReducer/Ecommerce/productSyncSlice';
import { selectYardRxLoading } from '../PerformanceReducer/Ecommerce/yardRxSlice';
import { selectLocalLiftMaxLoading } from '../PerformanceReducer/LocalLift/localLiftMaxSlice';

/**
 * Returns true while any dashboard data API call is still in-flight.
 * Used to gate the Print button so users cannot print before data is ready.
 */
export const selectIsAnyDataLoading = createSelector(
  [
    selectCardLoading,
    selectGridLoading,
    selectOverallLoading,
    selectEcommLoading,
    selectEcomOrderDetailsLoading,
    selectKeyOperationalMetricsLoading,
    selectProductSyncLoading,
    selectYardRxLoading,
    selectLocalLiftMaxLoading,
  ],
  (
    isCardLoading,
    isGridLoading,
    isOverallLoading,
    isEcommLoading,
    isEcomOrderDetailsLoading,
    isKeyOperationalMetricsLoading,
    isProductSyncLoading,
    isYardRxLoading,
    isLocalLiftMaxLoading,
  ): boolean =>
    isCardLoading ||
    isGridLoading ||
    isOverallLoading ||
    isEcommLoading ||
    isEcomOrderDetailsLoading ||
    isKeyOperationalMetricsLoading ||
    isProductSyncLoading ||
    isYardRxLoading ||
    isLocalLiftMaxLoading,
);
